import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { type BuildAndBuyLabelType, BnbLabel, getBnbOptionalLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";
import type { BuyTermsModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";

const labelKeys: BuildAndBuyLabelType[] = [
    "buyTermsConditionsDescription",
    "buyTermsConditionsScroll1",
    "buyTermsConditionsScroll2",
    "buyTermsConditionsExtra",
];

const monthlyLabelKeys: BuildAndBuyLabelType[] = [
    "buyTermsConditionsDescriptionMonthly",
    "buyTermsConditionsScroll1Monthly",
    "buyTermsConditionsScroll2Monthly",
    "buyTermsConditionsExtraMonthly",
];

const BuyTermsModal = (props: ModalViewType<BuyTermsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel
                        fallbackLabel="buyTermsConditionsTitle"
                        label={financeOption === "cash" ? "buyTermsConditionsTitle" : "buyTermsConditionsTitleMonthly"}
                    />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>

            <Modal.Body>
                {labelKeys.map(
                    (key, index) =>
                        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, key) && (
                            <div key={key}>
                                <BnbLabel
                                    fallbackLabel={key}
                                    label={financeOption === "cash" ? key : monthlyLabelKeys[index]}
                                    useHTML
                                />
                            </div>
                        ),
                )}
            </Modal.Body>
            <Modal.Actions>
                <Button.Primary onClick={close}>
                    <BnbLabel
                        fallbackLabel="buyTermsConditionsOk"
                        label={financeOption === "cash" ? "buyTermsConditionsOk" : "buyTermsConditionsOkMonthly"}
                    />
                </Button.Primary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default BuyTermsModal;
